import MediaPreview from '../../shared/MediaPreview'
import useMediaPreview from './useMediaPreview.ts'

const MediaPreviewService = () => {
  const mediaCtrl = useMediaPreview()

  if (!mediaCtrl.isActive) return null

  return <MediaPreview mediaCtrl={mediaCtrl} />
}

export default MediaPreviewService
